import React, { Component } from "react";
import { Row, Col, Card } from "antd";
import momentTZ from "moment-timezone";

class ApprovalInformation extends Component {
  render() {
    const { approval, approvalType } = this.props;
    let noApproval;
    let title;

    if (approvalType === "Trade In") {
      noApproval = approval ? approval.Appraisal.Booking.noBooking : null;
      title = "No. Appraisal";
    } else if (approvalType === "New Car") {
      noApproval = approval ? approval.noNewCar : null;
      title = "No. New Car";
    }
    return (
      <Row>
        <Col xs={24} md={12}>
          <Card title={title}>
            <span className="ant-form-text form-text-mod">{noApproval}</span>
          </Card>
        </Col>
        <Col xs={24} md={12}>
          <Card title="Hari/Tgl Approval">
            <span className="ant-form-text form-text-mod">
              {momentTZ(approval ? approval.createdAt : null)
                .tz("Asia/Jakarta")
                .format("ddd, D MMM YYYY HH:mm")}
            </span>
          </Card>
        </Col>
      </Row>
    );
  }
}

export default ApprovalInformation;



// WEBPACK FOOTER //
// src/components/Dashboard/Approval/Component/Section/ApprovalInformation.js